import type { ReactNode } from 'react';

import { LucideProvider } from 'lucide-react';

export {
  AlignCenterIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  AppleIcon,
  ArchiveIcon,
  ArrowDown,
  ArrowDownIcon,
  ArrowDownToLineIcon,
  ArrowDownWideNarrowIcon,
  ArrowLeft,
  ArrowLeftIcon,
  ArrowLeftRightIcon,
  ArrowLeftToLineIcon,
  ArrowRight,
  ArrowRightIcon,
  ArrowRightLeftIcon,
  ArrowRightToLineIcon,
  ArrowUp,
  ArrowUpDownIcon,
  ArrowUpIcon,
  ArrowUpRightIcon,
  ArrowUpToLineIcon,
  AtSign,
  AtSignIcon,
  AudioLinesIcon,
  BanIcon,
  BaselineIcon,
  Bell,
  BellIcon,
  BellOffIcon,
  BoldIcon,
  BookmarkIcon,
  BookmarkOffIcon,
  BookOpenIcon,
  BotIcon,
  BoxIcon,
  BracesIcon,
  Cake,
  CakeIcon,
  CalendarDaysIcon,
  CalendarIcon,
  CameraIcon,
  Check,
  CheckCheckIcon,
  CheckIcon,
  ChevronDown,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRight,
  ChevronRightIcon,
  ChevronUpIcon,
  ChevronsUpDownIcon,
  CircleAlertIcon,
  CircleCheckBig,
  CircleCheckIcon,
  CircleDashedIcon,
  CircleDotIcon,
  CirclePlusIcon,
  CircleUserIcon,
  ClipboardCopyIcon,
  ClockIcon,
  Code2,
  Code2Icon,
  Columns2Icon,
  Columns3Icon,
  Combine,
  CombineIcon,
  CompassIcon,
  CopyIcon,
  CornerDownLeftIcon,
  CornerDownRightIcon,
  CornerUpLeft,
  CornerUpLeftIcon,
  DatabaseIcon,
  DiamondIcon,
  DownloadIcon,
  EllipsisIcon,
  EllipsisVerticalIcon,
  EraserIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FileCodeIcon,
  FileIcon,
  FileTextIcon,
  FileUp,
  FileUpIcon,
  FilmIcon,
  FilterIcon,
  FilterXIcon,
  FlagIcon,
  FocusIcon,
  FolderIcon,
  FolderInputIcon,
  FolderPlusIcon,
  GlobeIcon,
  Grid2X2Icon,
  Grid3x3Icon,
  GripHorizontal,
  GripHorizontalIcon,
  GripVertical,
  GripVerticalIcon,
  Hash,
  HashIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  HighlighterIcon,
  History,
  HourglassIcon,
  ImageIcon,
  ImageOffIcon,
  InboxIcon,
  IndentIcon,
  InfoIcon,
  ItalicIcon,
  KanbanIcon,
  KeyRoundIcon,
  KeyboardIcon,
  LayersIcon,
  LayoutGridIcon,
  LeafIcon,
  LightbulbIcon,
  Link,
  Link2Icon,
  Link2OffIcon,
  LinkIcon,
  List,
  ListChecksIcon,
  ListCollapseIcon,
  ListFilterIcon,
  ListFilterPlusIcon,
  ListIcon,
  ListOrdered,
  ListOrderedIcon,
  ListTodoIcon,
  ListTreeIcon,
  Loader2Icon,
  LoaderCircleIcon,
  Lock,
  LockIcon,
  LockOpenIcon,
  LogOutIcon,
  LucideProvider,
  MailIcon,
  MailOpenIcon,
  Maximize2Icon,
  MapPinIcon,
  MapPinPlusIcon,
  MessageSquare,
  MessageSquareIcon,
  MessageSquareReplyIcon,
  MessageSquareTextIcon,
  MessagesSquareIcon,
  MicIcon,
  MicOffIcon,
  Minimize2Icon,
  Minus,
  MinusIcon,
  MonitorIcon,
  MoonIcon,
  MoreHorizontalIcon,
  MusicIcon,
  NotebookTextIcon,
  OctagonPauseIcon,
  OctagonXIcon,
  OutdentIcon,
  PaintBucketIcon,
  PaletteIcon,
  PanelBottomIcon,
  PanelLeftIcon,
  PanelRightIcon,
  Paperclip,
  PaperclipIcon,
  PauseIcon,
  PenIcon,
  PenToolIcon,
  PencilIcon,
  PencilLineIcon,
  PhoneIcon,
  PhoneOffIcon,
  PictureInPicture2Icon,
  PilcrowIcon,
  PinIcon,
  PlugZapIcon,
  PinOffIcon,
  PlayIcon,
  Plus,
  PlusIcon,
  QuoteIcon,
  RadicalIcon,
  Redo2Icon,
  RefreshCwIcon,
  RepeatIcon,
  ReplyIcon,
  RotateCcwIcon,
  RotateCwIcon,
  ScreenShareIcon,
  ScreenShareOffIcon,
  Search,
  SearchIcon,
  Send,
  SendIcon,
  ServerIcon,
  Settings2Icon,
  SettingsIcon,
  ShapesIcon,
  SignalHighIcon,
  SlidersHorizontalIcon,
  SmileIcon,
  SmilePlus,
  SmilePlusIcon,
  SnowflakeIcon,
  SquareArrowOutUpRightIcon,
  SquareCheckIcon,
  SquareCodeIcon,
  SquareIcon,
  SquareSplitHorizontalIcon,
  StarIcon,
  StarOffIcon,
  StrikethroughIcon,
  SunIcon,
  SubscriptIcon,
  SuperscriptIcon,
  Table,
  TableIcon,
  TableOfContentsIcon,
  TagIcon,
  TextIcon,
  Trash2,
  Trash2Icon,
  TrashIcon,
  TriangleAlertIcon,
  TriangleIcon,
  TypeIcon,
  UnderlineIcon,
  Undo2Icon,
  Ungroup,
  UngroupIcon,
  UserIcon,
  UserPlus,
  UserPlusIcon,
  UsersIcon,
  UsersRound,
  UsersRoundIcon,
  VideoIcon,
  VideoOffIcon,
  Volume2Icon,
  VolumeXIcon,
  WandSparklesIcon,
  WrapText,
  X,
  XIcon,
  ZoomInIcon,
  ZoomOutIcon,
  icons,
} from 'lucide-react';
export type { LucideIcon, LucideProps } from 'lucide-react';

export const ICON_STROKE = 1.25;

export function IconProvider({ children }: { children: ReactNode }) {
  return (
    <LucideProvider strokeWidth={ICON_STROKE} nonScalingStroke>
      {children}
    </LucideProvider>
  );
}
